import { COMPONENT_NAME } from 'components/pages/VideoDetails/constants';

export function getMessageForWatchResumeButton(isFinishWatchCondition: boolean) {
  return isFinishWatchCondition
    ? { defaultMessage: 'Watch', id: `${COMPONENT_NAME}.VideoContent.buttonWatch` }
    : { defaultMessage: 'Resume', id: `${COMPONENT_NAME}.VideoContent.buttonResume` };
}
